interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  articlePublishedTime?: string;
  articleModifiedTime?: string;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage,
  articlePublishedTime,
  articleModifiedTime,
}: SEOHeadProps) {
  const fullTitle = `${title} | 无遮韩国免费漫画大全`;
  const siteUrl = 'https://manhwa-free.com';
  const fullCanonical = canonicalUrl.startsWith('http') ? canonicalUrl : `${siteUrl}${canonicalUrl}`;
  const defaultImage = 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20website%20with%20colorful%20comic%20panels%20and%20characters%2C%20vibrant%20and%20energetic%20atmosphere%2C%20modern%20design%2C%20clean%20simple%20background&width=1200&height=630&seq=og-default&orientation=landscape';

  const ogImageUrl = ogImage || defaultImage;
  const lastModified = articleModifiedTime || articlePublishedTime || new Date().toISOString().split('T')[0];

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullCanonical} />
      <meta httpEquiv="Last-Modified" content={lastModified} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:image" content={ogImageUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="无遮韩国免费漫画大全" />
      <meta property="og:locale" content="zh_CN" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImageUrl} />

      <meta name="geo.region" content="CN-11" />
      <meta name="geo.placename" content="北京" />
      <meta name="geo.position" content="39.9042;116.4074" />
    </>
  );
}